module.exports = __webpack_public_path__ + "img/ylq_zhCn.24cc5c55.png";